import { Language } from './lang';
import { HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { getUserId } from './user';

export const actionUrl: string = "https://publicservice.evoca.am/api/PaymentService";

export function getHeaders(standardCase: boolean) {
    const headers = {
        'Content-Type': 'application/json',
        'X-Device': getUserId(),
        'ServiceAuthToken': standardCase ? 'UTGZBQllANzpFY2dYNdi5POSVtwO3q7j' : 'e04d22dd-e8a8-4645-bd1c-977983281ad7',
        'X-Language': Language.getCurrentLang()
    };
    return {
        headers: new HttpHeaders(headers)
    };
};

export function handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
        // log(`${operation} failed: ${error.message}`); /// todo comment for production
        result = error;
        return of(result as T);
    };
}

function log(message: string) {
    console.log(`errormessage: ${message}`);
}
